import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneIphoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_iphone"}/>
}
